export default "__VITE_ASSET__SrAIoFsY__"